import {signal} from "@angular/core";

export const preferred_lang = signal('en');
